import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FiltersService } from '@app/shared/services/filters.service';
import { RestMessage } from '@app/core/types';
import { catchError, timeout } from 'rxjs/operators';
import { HelperService } from '@clearviewshared/services/helper.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class PresidentReportExtractService {
  reportingUrl = '/reporting';
  headers: HttpHeaders;
  options: any;

  constructor(
    private http: HttpClient,
    private filtersService: FiltersService,
    private helperService: HelperService,
    private translateService: TranslateService
  ) {}

  async getPresidentExtractExport(filename: string) {
    let translatedFilename = this.translateService.instant(filename);

    const filters = this.filtersService.getFilterObject();
    const date = new Date(filters.EndDate);
    const monthName = date.toLocaleString('en-US', { month: 'long' });
    translatedFilename = translatedFilename + this.translateService.instant(monthName) + '-' + date.getFullYear();

    this.headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    this.options = {
      observe: 'response',
      headers: this.headers,
      responseType: 'blob',
    };

    var url = `${this.reportingUrl}/president-extract`;

    return await this.http
      .post<RestMessage>(url, filters, this.options)
      .pipe(
        timeout(360000000),
        catchError((err: any) => {
          return null;
        })
      )
      .subscribe((response) => {
        this.helperService.exportExelFile(response, translatedFilename);
      });
  }
}
